import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import RecruiterSideUsersSwiperComponent from './RecruiterSideUsersSwiperComponent';
import { Button } from 'flowbite-react';
import { isRecruiterSide } from 'src/config/env.config';
import { useMutation } from 'react-query';
import { recordFETracking } from 'src/apis/tracking';
import { TrackingType } from 'types';
import { RECRUITER_APP_ENDPOINT } from 'src/config/env.config';

const DemoWrapper = () => {
	const { user } = useUserContext();
	const [searchParamas] = useSearchParams();
	const navigate = useNavigate();

	const [recordedLanding, setRecordedLanding] = useState(false);

	const redirectUrl = searchParamas.get('redirect_url');
	const prefilledEmail = searchParamas.get('email');
	const bookADemoLink = searchParamas.get('link') || 'https://calendar.app.google/W5KUfkhPxxBi34KEA';

	const recordFETrackingFn = useMutation(['recordFETracking'], recordFETracking, {
		onSuccess() {
			setRecordedLanding(true);
			console.log('success tracking');
		},
		onError() {
			console.log('error');
		},
	});

	useEffect(() => {
		if (user) {
			if (redirectUrl) {
				window.open(decodeURIComponent(redirectUrl), '_self');
			} else {
				// navigate('/dashboard');
				navigate('/my-applications');
			}
		}
	});

	useEffect(() => {
		if (bookADemoLink && isRecruiterSide && prefilledEmail && !recordedLanding) {
			recordFETrackingFn.mutate({
				type: TrackingType.FLYWHEEL_LEAD_LANDED_ON_BOOK_A_DEMO,
				createdAt: new Date(),
				meta: {
					email: prefilledEmail,
					demoLink: bookADemoLink,
					url: window.location.href,
				},
			});
		}
	}, [bookADemoLink, prefilledEmail, isRecruiterSide, recordedLanding]);

	return (
		<div
			className={
				' bg-[#FFF] p-3 h-[100%] flex flex-col m-[auto]  md:m-[0px]  min-w-[360px] md:min-w-[400px] justify-start md:justify-center md:gap-10 relative bg-no-repeat !bg-cover '
			}
		>
			<div className="md:max-w-[335px] mx-auto ">
				<RecruiterSideUsersSwiperComponent />
				<div className="flex md:flex-col gap-2 md:gap-5 justify-start items-center md:items-start ">
					<div>
						<span className="text-sm md:text-lg font-[500] text-[#1F2A37]">
							Get a free demo session with one of our experts.
						</span>
					</div>
					<Button
						color="purplePlaced"
						onClick={() => {
							if (prefilledEmail && bookADemoLink)
								recordFETrackingFn.mutate({
									type: TrackingType.FLYWHEEL_CLICKED_BOOK_A_DEMO,
									createdAt: new Date(),
									meta: {
										email: prefilledEmail,
										demoLink: bookADemoLink,
										url: window.location.href,
									},
								});
							window.open(bookADemoLink || `${RECRUITER_APP_ENDPOINT}/auth/bookADemo`);
						}}
						className={'w-full whitespace-pre'}
					>
						Book a 15 mins demo
					</Button>
					{/* <div className="mb-5 flex gap-2 text-base dark:text-[#C7C9D9] text-[#28293D]">
					Explore on my own,
					<Link data-testid="auth-link-signin" className="text-[#7777E7]" to="/auth/signin">
						Sign In
					</Link>
				</div> */}
				</div>
			</div>
		</div>
	);
};

export default DemoWrapper;
